import Vue from 'vue'
import VueI18n from 'vue-i18n'

const enData = require('@/assets/languages/AhaSlides_English.json')
const viData = require('@/assets/languages/AhaSlides_Vietnamese.json')
const esData = require('@/assets/languages/AhaSlides_Spanish.json')
const brData = require('@/assets/languages/AhaSlides_Portuguese_BR.json')
const frData = require('@/assets/languages/AhaSlides_French.json')
const deData = require('@/assets/languages/AhaSlides_German.json')
const itData = require('@/assets/languages/AhaSlides_Italian.json')
const trData = require('@/assets/languages/AhaSlides_Turkish.json')
const jaData = require('@/assets/languages/AhaSlides_Japanese.json')
const nlData = require('@/assets/languages/AhaSlides_Dutch.json')
const ruData = require('@/assets/languages/AhaSlides_Russian.json')
const plData = require('@/assets/languages/AhaSlides_Polish.json')
const daData = require('@/assets/languages/AhaSlides_Danish.json')
const zhData = require('@/assets/languages/AhaSlides_Traditional_Chinese.json')
const slData = require('@/assets/languages/AhaSlides_Slovenia.json')
const siData = require('@/assets/languages/AhaSlides_Slovenia.json')

const formatDataLanguage = (data) => {
  const obj = {}
  data.forEach((item) => {
    obj[item.term] = item.definition
  })
  return obj
}

Vue.use(VueI18n)
const locale = 'en'
const messages = {
  en: formatDataLanguage(enData),
  vi: formatDataLanguage(viData),
  es: formatDataLanguage(esData),
  br: formatDataLanguage(brData),
  fr: formatDataLanguage(frData),
  de: formatDataLanguage(deData),
  it: formatDataLanguage(itData),
  tr: formatDataLanguage(trData),
  ja: formatDataLanguage(jaData),
  nl: formatDataLanguage(nlData),
  ru: formatDataLanguage(ruData),
  pl: formatDataLanguage(plData),
  da: formatDataLanguage(daData),
  zh: formatDataLanguage(zhData),
  sl: formatDataLanguage(slData),
  si: formatDataLanguage(siData),
}
const i18n = new VueI18n({
  locale,
  fallbackLocale: locale,
  formatFallbackMessages: true,
  messages,
})
export default i18n
